import { z } from 'zod'
import { NativeMessageSchema } from './NativeMessage'

export const LogoutMessageSchema = z.object({
  type: z.literal('logout'),
}).extend(NativeMessageSchema.shape)

export type LogoutMessage = z.infer<typeof LogoutMessageSchema>
